import { render, staticRenderFns } from "./Xpress.vue?vue&type=template&id=104414be&"
import script from "./Xpress.vue?vue&type=script&lang=js&"
export * from "./Xpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports